import React from 'react'

const Tshirts = () => {
  return (
    <div>Tshirts</div>
  )
}

export default Tshirts